
import { Newspaper,  Zap, Filter, Loader } from 'lucide-react';

export const Sidebar = ({ sources, selectedSource, onSelectSource, onRefresh }) => (
    <aside className="lg:w-64 w-full p-5 bg-gradient-to-b from-slate-800/60 to-slate-900/60 backdrop-blur-md rounded-xl shadow-xl border border-teal-500/10 self-start sticky top-24">
        <div className="flex justify-between items-center mb-6">
            <h2 className="text-lg font-bold text-white flex items-center">
                <div className="p-2 bg-teal-500/20 rounded-lg mr-3">
                    <Filter className="w-5 h-5 text-teal-400"/> 
                </div>
                সংবাদ উৎস
            </h2>
        </div>
        <ul className="space-y-2">
            <li 
                onClick={() => onSelectSource('All')}
                className={`cursor-pointer p-4 rounded-lg transition-all duration-300 flex items-center font-medium ${selectedSource === 'All' ? 'bg-gradient-to-r from-teal-500 to-cyan-500 text-white shadow-lg shadow-teal-500/30' : 'text-gray-300 hover:bg-slate-700/50 hover:text-teal-300'}`}
            >
                <Zap size={18} className="mr-3"/> সব সংবাদ
            </li>
            {sources.map((source, idx) => (
                <li 
                    key={source} 
                    onClick={() => onSelectSource(source)}
                    className={`cursor-pointer p-4 rounded-lg transition-all duration-300 flex items-center font-medium ${selectedSource === source ? 'bg-gradient-to-r from-teal-500 to-cyan-500 text-white shadow-lg shadow-teal-500/30' : 'text-gray-300 hover:bg-slate-700/50 hover:text-teal-300'}`}
                    style={{ animationDelay: `${idx * 50}ms` }}
                >
                    <Newspaper size={18} className="mr-3"/> {source}
                </li>
            ))}
        </ul>
        <button 
          onClick={onRefresh} 
          className="w-full mt-8 bg-gradient-to-r from-indigo-600 to-purple-600 text-white py-3 px-4 rounded-lg hover:from-indigo-700 hover:to-purple-700 transition-all duration-300 flex items-center justify-center shadow-lg hover:shadow-purple-500/30 font-semibold"
        >
          <Loader className="w-4 h-4 mr-2 "/> রিফ্রেশ করুন
        </button>
    </aside>
);